import { createContext } from 'react'
import { AuthStore } from './AuthStore'
import { JobsStore } from './JobsStore'
import { UserStore } from './UserStore'
import { FundStore } from './FundStore'
import { CommonConfigStore } from './CommonConfigStore'
import { DebtsStore } from './DebtsStore'
import { JobDetailStore } from './JobDetailStore'
import { DashboardStore } from './DashboardStore'
import { ApiKeyStore } from './ApiKeyStore'

export const stores = Object.freeze({
   AuthStore: new AuthStore(),
   JobsStore: new JobsStore(),
   UserStore: new UserStore(),
   FundStore: new FundStore(),
   CommonConfigStore: new CommonConfigStore(),
   DebtsStore: new DebtsStore(),
   JobDetailStore: new JobDetailStore(),
   DashboardStore: new DashboardStore(),
   ApiKeyStore: new ApiKeyStore()
})

export const storesContext = createContext(stores)
export const StoresProvider = storesContext.Provider
